import { render } from "./PMM.vue?vue&type=template&id=22ae342f"
import script from "./PMM.vue?vue&type=script&lang=js"
export * from "./PMM.vue?vue&type=script&lang=js"

import exportComponent from "/opt/FE_Compro/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__